import React from "react";
import { CheckIcon, GiftIcon, SparklesIcon } from "lucide-react";
import { SectionCta } from "../SectionCta";
import { bonuses, workflowSteps } from "../../data/content";
export function Bonuses() {
  return <section className="bg-navy-950 px-4 py-16 text-white sm:px-6 sm:py-24" aria-labelledby="bonuses-title" data-id="element-114" data-mp="1cm7r8gwyk5h9">
      <div className="mx-auto max-w-3xl text-center" data-id="element-115" data-mp="18kvw5vvbes1o">
        <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-gold-400 text-navy-950" data-id="element-116" data-mp="259v9hparak0q">
          <GiftIcon className="h-7 w-7" aria-hidden="true" data-id="element-117" data-mp="20a8w9fuxh3rx" />
        </span>
        <h2 id="bonuses-title" className="mt-5 font-display text-[30px] font-black leading-tight sm:text-5xl" data-id="element-118" data-mp="1w95egntbkxo2">
          5 Exclusive <span className="text-gold-400" data-id="element-119" data-mp="1raltoqqgprxa">Professional Bonuses</span>
        </h2>
        <p className="mt-4 text-lg text-white/75" data-id="element-120" data-mp="ktqi9m8xq9u0">Included free with your Blueprint today.</p>
      </div>

      <div className="mx-auto mt-14 max-w-6xl space-y-16 sm:space-y-24" data-id="element-121" data-mp="fv6tle2yijxy">
        {bonuses.map((b, i) => <article key={b.number} className="grid items-center gap-8 lg:grid-cols-2 lg:gap-14" aria-labelledby={`bonus-${b.number}`} data-id="element-122" data-mp="1et59iw0fe57h" data-mpi={i}>
            <div className={`-mx-4 sm:mx-0 ${i % 2 === 1 ? "lg:order-2" : ""}`} data-id="element-123" data-mp="15t8or5h5pqhp">
              <img src={b.image} alt={`Bonus #${b.number}: ${b.title}`} className="w-full rounded-none bg-white sm:rounded-3xl" loading="lazy" data-id="element-124" data-mp="15vbb9fj3p1ho" />
            </div>

            <div data-id="element-125" data-mp="10u5gzd9sl661">
              <div className="flex flex-wrap items-center gap-3" data-id="element-126" data-mp="10unm6zefmuq3">
                <span className="rounded-lg bg-gold-400 px-3 py-1 font-display text-sm font-black uppercase text-navy-950" data-id="element-127" data-mp="n30pwzkhpm7b">
                  Bonus #{b.number}
                </span>
                <span className="text-sm font-semibold text-white/70" data-id="element-128" data-mp="d4b4iwtdxjmb">
                  Suggested value <span className="line-through" data-id="element-129" data-mp="d6no1eesk21h">${b.value}</span>
                </span>
                <span className="rounded-lg bg-success px-2.5 py-1 text-xs font-bold uppercase text-white" data-id="element-130" data-mp="i5gysz2p1exy">
                  Free today
                </span>
              </div>
              <h3 id={`bonus-${b.number}`} className="mt-4 font-display text-2xl font-black leading-tight sm:text-3xl" data-id="element-131" data-mp="2f0achl37ffp3">
                {b.title}
              </h3>
              <p className="mt-3 text-[17px] leading-relaxed text-white/80" data-id="element-132" data-mp="261yakmww0vhc">{b.description}</p>

              {b.number === 5 && <ol className="mt-6 space-y-2.5 rounded-2xl bg-white/[0.06] p-4 ring-1 ring-white/10 sm:p-5" data-id="element-133" data-mp="32qw7obs415ho">
                  <li className="mb-1 font-display text-sm font-extrabold uppercase text-gold-400" data-id="element-134" data-mp="2yqlyyrcxo0z4">The 15-minute workflow</li>
                  {workflowSteps.map(s => <li key={s.minutes} className="flex gap-3 text-base leading-snug" data-id="element-135" data-mp="2oqv58rw75q03">
                      <span className="w-[78px] shrink-0 rounded-md bg-gold-400 px-2 py-0.5 text-center text-sm font-black text-navy-950" data-id="element-136" data-mp="1icm43usy31iq">
                        Min {s.minutes}
                      </span>
                      <span className="text-white/90" data-id="element-137" data-mp="139vtut1kenud">{s.text}</span>
                    </li>)}
                </ol>}

              <p className="mt-6 text-sm font-bold uppercase tracking-wide text-white/60" data-id="element-138" data-mp="1d6qr78m3qi72">Includes</p>
              <ul className="mt-3 space-y-2.5" data-id="element-139" data-mp="1hxgumgaywaz4">
                {b.includes.map(item => <li key={item} className="flex gap-2.5 text-base leading-snug text-white/95" data-id="element-140" data-mp="1hza1nwphsx7n">
                    <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold-400" strokeWidth={3} aria-hidden="true" data-id="element-141" data-mp="1m1esyosgxhr4" />
                    {item}
                  </li>)}
              </ul>
              <div className="mt-6 flex gap-3 rounded-2xl bg-white p-4 text-ink" data-id="element-142" data-mp="20wbaxtq2xjhe">
                <SparklesIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold-600" aria-hidden="true" data-id="element-143" data-mp="20u8lpbwr3udq" />
                <p className="text-base leading-snug" data-id="element-144" data-mp="1la9x90swdvh">
                  <strong data-id="element-145" data-mp="6jbnxfjddn03">Why you'll want it:</strong> {b.why}
                </p>
              </div>
              {b.number === 5 && <p className="mt-4 text-xs leading-relaxed text-white/55" data-id="element-146" data-mp="1x1idena0x4el">
                  The 15-minute workflow is an organizational exercise, not a replacement for a complete clinical
                  examination or a promise that every case can be fully planned within that time.
                </p>}
            </div>
          </article>)}
      </div>

      <SectionCta label="Yes! I want all 5 professional bonuses" tone="dark" data-id="element-147" data-mp="1dby4lctxrw6k" />
    </section>;
}